/*

  * Custom Input Has Functionality of Input with dropdown. We can choose values from dropdown for input or can write directly.
  * If we don't pass onChange then bydefault it will set the setInputValue to inputValue else we can customize onChange
  
*/

import React, { useState } from 'react';

const Input = ({dropdownOptions, inputValue, setInputValue, onChange, placeholder, required}) => {

  const [showDropdown, setShowDropdown] = useState(false);

  const handleFocus = () => {
    setShowDropdown(true);
  };

  const handleBlur = () => {
    // Delay hiding the dropdown to allow selection
    setTimeout(() => setShowDropdown(false), 200);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleItemClick = (value) => {
    setInputValue(value);
    if(onChange) onChange(value)
    setShowDropdown(false);

  };


  return (
    <div className="position-relative w-100">
      <input
        type="text"
        className="form-control text-primary font-monospace"
        value={inputValue}
        onChange={(e) => onChange(e.target.value) ?? handleInputChange(e)}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        required={required}
      />

      {showDropdown && (
        <ul className="list-group position-absolute w-100" style={{ zIndex: 1000, maxHeight: '300px', overflowY: 'auto'}}>
          {dropdownOptions
            .filter((dropdownOption) => dropdownOption.toLowerCase().includes(inputValue.toLowerCase()))
            .map((dropdownOption, index) => (
              <li
                key={index}
                className="list-group-item list-group-item-action"
                onClick={() => handleItemClick(dropdownOption)}
                style={{ cursor: 'pointer' }}
              >
                {dropdownOption}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default Input;
